import { useMemo } from "react";
import type { PriceRow } from "@/lib/prices-shared";
import type { IndexSeries } from "@/lib/price-index.shared";
import { movementNote } from "@/lib/index-movement";

/**
 * One compact, auto-written line explaining the latest market move, rendered
 * directly above the numbers it describes. Deliberately a single paragraph —
 * no card, no heading, no extra chrome — so it adds context without clutter.
 */
export function MarketMovementNote({
  rows,
  series,
  className = "",
}: {
  rows: PriceRow[];
  series?: IndexSeries | null;
  className?: string;
}) {
  const note = useMemo(() => movementNote(rows, series), [rows, series]);
  if (!note) return null;

  const tone =
    note.direction === "up"
      ? "border-emerald-400/40 text-emerald-100/90"
      : note.direction === "down"
        ? "border-rose-400/40 text-rose-100/90"
        : "border-white/15 text-white/70";

  return (
    <p className={`aeo-answer border-l-2 pl-3 text-sm ${tone} ${className}`}>
      <span className="sr-only">Why the market moved: </span>
      {note.text}
    </p>
  );
}
